import React from 'react'
const Card = ({icon, title, value, color}) => {
    return (
      <div className='w-full items-center space-x-6 bg-white text-dark p-4 rounded-lg shadow-md flex  border border-stone-200'>
          <div className='w-12 h-12 md:w-16 md:h-16 border border-gray-400 rounded-full flex items-center text-center justify-center '>
             <div className='w-6 h-6 md:w-8 md:h-8 text-3xl text-gray-500 fill-current m-auto'>{icon}</div>
          </div>     
          <div className='flex flex-col justify-center items-center'>
            <h2 className={`text-base md:text-xl font-bold ${color}`}>{value}</h2>
            <p className='text-sm md:text-xs font-light text-gray-500'>{title}</p>
          </div>
          
      </div>
      
    )
  }
  
  export default Card